
import { Outlet } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import CookieConsent from './components/CookieConsent'

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-cloud text-ink">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <CookieConsent />
    </div>
  )
}
